import { css } from '@emotion/core';
import media from 'css-in-js-media';
import styled from '@emotion/styled';

export const styledHeroBoxSection = css`
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: cover;

  .column {
    margin: auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .hero-body {
    display: flex;
    align-items: center;
  }

  ${media('<largeDesktop')} {
    .is-7,
    is-4 {
      width: 38%;
    }
  }

  ${media('<desktop')} {
    height: auto;
    .columns {
      flex-direction: column;
    }
    .column {
      width: 100%;
    }
    .is-7,
    is-4 {
      width: 100%;
    }
  }

  ${media('<tablet')} {
    .columns {
      margin-right: 0;
    }
  }
`;

export const styledHeroBoxWrapper = css`
  padding: 3rem 1.5rem;
`;

export const styledHeroBoxFullscreen = css`
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${media('<desktop')} {
    height: 100vh;
  }
`;

export const styledHero = css`
  display: flex;
  justify-content: center;

  .title {
    margin-top: 40px;
    max-width: 670px;
  }

  .medium {
    margin-top: 20px;
    max-width: 670px;
    font-size: 24px !important;
  }

  button {
    max-width: 300px;
  }

  ${media('<desktop')} {
    margin: auto !important;
    text-align: center;
  }
`;

export const StyledSmallHeading = styled.div`
  display: flex;

  h6 {
    letter-spacing: 1px !important;
    margin: 0;
    margin-top: 5px !important;
    text-transform: uppercase !important;
  }

  ${media('<desktop')} {
    margin-right: 0px;
    justify-content: center;
    h6 {
      margin-right: 10px !important;
    }
  }
`;

export const StyledHeadings = styled.div`
  display: flex;
  flex-direction: column;

  h1,
  p {
    margin: 0;
  }

  img {
    margin-right: 10px;
    height: 22px;
    width: 22px;
  }

  .title {
    word-break: normal;
  }

  ${media('<desktop')} {
    justify-content: center;
    h1,
    p {
      margin: auto;
    }
  }
`;

export const styledHeroBox = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 360px;
  margin: auto;
  border-radius: 6px;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 220px;
    text-align: center;
    padding: 32px;
    width: 85%;
  }

  ${media('<tablet')} {
    min-width: 240px;
  }
`;

export const styledHeroBoxTitle = css`
  flex: 0 !important;
  width: 92.8%;
  justify-content: center;
  border-radius: 6px 6px 0px 0px;
  background-color: #f3f5f9;

  h5 {
    margin-top: 0px;
    display: flex;
    align-items: center;
    height: 36px;
  }

  ${media('<tablet')} {
    width: 90%;
  }
`;

export const StyledFeatureList = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: 115px;
  margin-left: 20px;
  text-align: left;
  list-style: none;

  img {
    width: 16px;
    height: 16px;
    margin-right: 16px;
  }

  li {
    margin-top: 10px;
  }

  div {
    display: flex;
    align-items: center;
  }
`;

export const styledButton = css`
  margin-top: 25px;
`;

export const styledLeftButton = css`
  margin-top: 32px;
  max-width: 300px;

  ${media('< desktop')} {
    align-self: center;
  }
`;

export const HeroTextContentContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  flex-wrap: wrap;

  ${media('<tablet')} {
    flex-wrap: wrap;
    text-align: center;
  }
`;

export const HeroBoxFormContainer = styled.div`
  width: 32%;
  max-width: 370px;

  ${media('<tablet')} {
    width: 100%;
    margin: 0 auto;
  }
`;

export const heroTextNoForm = css`
  width: 100%;
  text-align: center;
`;

export const heroTextForm = css`
  width: 64%;
  margin-right: 2%;

  ${media('<tablet')} {
    width: 100%;
    margin-bottom: 50px;
    margin-right: 0;
  }
`;

export const styledHeroBoxForm = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 370px;
  margin: 0;
  border-radius: 6px;

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 220px;
    text-align: center;
    padding: 32px;
  }

  ${media('<desktop')} {
    min-width: 320px;
    max-width: 370px;
    margin-top: 32px;
  }
`;

export const styledHeroBoxTitleForm = css`
  flex: 0 !important;
  width: 100%;
  justify-content: center;
  border-radius: 6px 6px 0px 0px;
  background-color: #f3f5f9;
  padding: 16px 0 12px 0;

  h5 {
    margin-top: 0px;
    display: flex;
    align-items: center;
    height: 36px;
  }
`;

export const StyledForm = styled.form`
  .form-wrapper {
    display: inline-block;
    text-align: left;
  }

  .hide-error {
    display: none;
  }

  .show-error {
    display: block;
  }

  input {
    width: 100%;
    height: 48px;
    border: 1px solid #e5e8ed;
    box-sizing: border-box;
    border-radius: 3px;
    margin-bottom: 8px;

    font-family: 'WorkSans-Regular';
    font-size: 16px;
    padding: 16px;
    color: #031b4e;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    :focus {
      border-color: #0069ff;
      outline: #0069ff;
    }
  }

  input.error-border {
    border: solid 1px #ca0c0c;
  }

  input[type='submit'] {
    background: #0069ff;
    border: none;
    line-height: 100%;
    font-family: 'WorkSans-Bold';
    color: #fff;
    padding: 17px;
    cursor: pointer;
    margin-bottom: 0;
  }

  span.error-text {
    color: #ca0c0c;
    display: inline-block;
    font-family: 'WorkSans-Regular';
    font-size: 12px;
    margin-bottom: 16px;
    text-align: left;
  }
`;

export const styledSubmit = css`
  width: 100%;
`;

export const StyledButtonsContainer = styled.div`
  border-top: 1px solid #f3f5f9;
  width: 306px;
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
`;

export const StyledButtonsContainerHr = styled.div`
  border-top: 1px solid #f3f5f9;
  width: 100%;
  padding: 32px 0 0 0;
`;

export const styledButtonForm = css`
  height: 48px;
  padding: 16px;
  margin: 0;
  border: 1px solid #0069ff;
`;

export const styledButtonWTextForm = css`
  height: 48px;
  padding: 13px 30px 16px 30px;
  margin: 0;
  display: flex;
  align-items: flex-start;
  border: 1px solid #0069ff;
  color: #0069ff;

  img {
    margin-top: 1px;
    margin-right: 6px;
  }
`;

export const StyledSubscript = styled.div`
  max-width: 370px;
  min-width: 370px;

  ${media('<desktop')} {
    min-width: 320px;
    max-width: 370px;
  }

  p,
  a {
    font-family: 'WorkSans-Regular';
    font-size: 12px;
    text-align: center;
    color: #fff;
  }

  a:hover {
    color: white !important;
    border-bottom: dotted 1px rgba(255, 255, 255, 0.5);
  }
`;
